/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ billed: NonNullable<unknown> }} Partner_Summary_BilledInputs */



/**
* | output |
* | --- |
* | "{billed} customers billed" |
*
* @param {Partner_Summary_BilledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_billed = /** @type {((inputs: Partner_Summary_BilledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_BilledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.billed} Kunden abgerechnet`)
	return /** @type {LocalizedString} */ (`${i?.billed} customers billed`)
});